import { render, staticRenderFns } from "./slider.pug?vue&type=template&id=d31dcf98&lang=pug&"
import script from "./slider.js?vue&type=script&lang=js&"
export * from "./slider.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d31dcf98')) {
      api.createRecord('d31dcf98', component.options)
    } else {
      api.reload('d31dcf98', component.options)
    }
    module.hot.accept("./slider.pug?vue&type=template&id=d31dcf98&lang=pug&", function () {
      api.rerender('d31dcf98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/slider/index.vue"
export default component.exports